const moduleName = "index";
const modulePath = `module/${moduleName}/`;
export const moduleFnUrl = (modfn: string) => `/${modulePath}${modfn}`;


const { createApp } = Vue
const { createVuetify } = Vuetify

import Login from './components/login.vue';
import Restore from './components/restorepassword.vue';

import colors from 'vuetify/util/colors';
import { ru } from 'vuetify/locale'

const run = () => {
  const vuetify = createVuetify({
    locale: {
      locale: 'ru',
      fallback: 'en',
      messages: { ru },
    },
    theme: {
      themes: {
        light: {
          dark: false,
          colors: {
            // primary: colors.blue.base,
            secondary: colors.grey.darken3,
          }
        },
      },
    },
  });

  const vueApp = createApp({})
  vueApp.use(vuetify);

  vueApp.component('login', Login);
  vueApp.component('restorepassword', Restore);

  vueApp.mount("#appcontainer");
}

run();
